export default class Config {
  constructor() {

    const baseUrl = process.env.VUE_APP_BASE_URL;
    const apiName = process.env.VUE_APP_API_NAME;
    const apiIntranet = process.env.VUE_APP_INTRANET_URL;
    const apiStorage = process.env.VUE_APP_STORAGE_URL;

    // Concatena a base URL com o nome do projeto manipulado caso ele exista, senão utiliza apenas baseUrl
    /**URL DA API DO SISFROTA */
    this._api_url = apiName ? `${baseUrl}/${apiName}/` : `${baseUrl}/`;

    /**URL DA API DA INTRANET */
    this._api_url_intra = apiIntranet;

    this._api_storage = apiStorage;

  }

  get api_url() {
    return this._api_url;
  }

  set api_url(value) {
    this._api_url = value;
  }

  get api_url_intra() {
    return this._api_url_intra;
  }

  set api_url_intra(value) {
    this._api_url_intra = value;
  }

  get api_storage() {
    return this._api_storage;
  }

  set api_storage(value) {
    this._api_storage = value;
  }
}
